import { Link } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";
import { AppHeader } from "@/components/AppHeader";
import { usePermissions } from "@/lib/permissions";

export const RequirePerm = ({ perm, children }) => {
  const { can, loaded, role } = usePermissions();
  if (!loaded) return null;
  if (can(perm)) return children;
  return (
    <div className="grain min-h-screen">
      <AppHeader title="No access" />
      <main className="relative z-10 pt-6">
        <div
          data-testid="no-access-panel"
          className="mx-auto mt-10 max-w-md rounded-lg border border-zinc-800 bg-zinc-900 p-8 text-center"
        >
          <Lock size={26} weight="bold" className="mx-auto text-amber-400" />
          <h1 className="mt-3 text-lg font-bold">This area is restricted</h1>
          <p className="mt-2 text-sm text-zinc-400">
            Your role ({role || "unknown"}) does not have access here. Ask an
            admin to change your role if you need it.
          </p>
          <Link
            to="/"
            data-testid="no-access-home"
            className="mt-5 inline-block rounded-full border border-indigo-400/40 bg-indigo-500/10 px-4 py-2 text-[11px] uppercase tracking-widest text-indigo-300 hover:bg-indigo-500/20"
          >
            Back to dashboard
          </Link>
        </div>
      </main>
    </div>
  );
};
